/* eslint-disable import/no-unresolved */
import React from 'react';
import MainLayout from './partials/MainLayout';
import { loyaltyScreens } from '../../../utilities/constants';
import { LoyaltyProvider } from '../../../contexts/loyalty/context';
import SelectWallet from './ClaimReward';
import SelectCashback from './SelectCashback';

export const PaymentBannerInfo = () => (
  <LoyaltyProvider>
    <MainLayout>
      <SelectWallet keyName={loyaltyScreens.CLAIM_REWARD} />
      <SelectCashback keyName={loyaltyScreens.SELECT_CASHBACK} />
    </MainLayout>
  </LoyaltyProvider>
);

export default PaymentBannerInfo;
